import { Component, OnInit } from '@angular/core';
import * as _moment from 'moment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IStudent } from '@app/modules/compliance/model/student';
import { Guid } from 'guid-typescript';
import { ApiResult } from '@app/shared/model/apiresult';
import { ActivatedRoute } from '@angular/router';
import { StudentAthleteService } from '@app/modules/compliance/services/student-athlete.service';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-coursesearch',
    templateUrl: 'course-search.component.html'
})

export class CourseSearchComponent implements OnInit {
    public student: IStudent;
    public code: string;
    url: string = environment.ncaaURL;
    urlSafe: SafeResourceUrl;

    constructor(
        private sanitizer: DomSanitizer,
        private _route: ActivatedRoute,
        private _studentathleteservice: StudentAthleteService
    ) {
    }
    ngOnInit() {
        this.student = null;
        this._route.queryParams.subscribe(params => {
            this.get(params.id);
            this.code=params.code;
        });
        this.url = this.url.replace("{0}",this.code);
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
    private get(id: Guid) {
        this._studentathleteservice.get(id).subscribe((result: ApiResult<IStudent>) => {
            if (result.validationErrors == null && result.value != null) {
                this.student = result.value;
            }
        }, error => console.error(error));
    }
}